import React, { useContext } from "react";
import DashboardMenus from "./DashboardMenus.js";
import AppContext from "../../context/AppContext.js";
const Header = ({setShowNames, showNames}) => {
  const { theme } = useContext(AppContext);
  return (
    <header
      className={` ${theme === "dark"
        ? "dark-mode"
        : theme === "high-contrast"
          ? "high-contrast"
          : ""
        } h-full w-full`}
    >
      <div
        className={`${theme === "dark"
          ? "dark-mode"
          : theme === "high-contrast"
            ? "high-contrast"
            : ""
          } h-full w-full`}
      >
        <div
          className={`flex h-full w-full items-center gap-4  ${theme === "dark"
            ? "dark-mode"
            : theme === "high-contrast"
              ? "high-contrast"
              : ""
            }`}
        >
          <div className="hidden h-full w-full lg:block ">
            <DashboardMenus setShowNames={setShowNames} showNames={showNames}/>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
